import { useState } from 'preact/hooks';
import { LEVELS, LEVEL_LABELS, asLevel } from '../lib/levels.ts';
import { SignOutButton } from '../components/SyncBadge.tsx';
import { useStore } from '../store/store.ts';
import { useSyncStatus } from '../sync/status.ts';
import { resyncFromScratch, syncNow } from '../sync/sync.ts';
import { toast } from '../ui/ui-store.ts';

export function AccountPage() {
  const settings = useStore((s) => s.settings);
  const saveSettings = useStore((s) => s.saveSettings);

  const [teacher, setTeacher] = useState(settings.teacher);
  const [className, setClassName] = useState<string>(asLevel(settings.className));
  const [schoolYear, setSchoolYear] = useState(settings.schoolYear);

  function save() {
    saveSettings({ teacher, className, schoolYear });
    toast('Réglages enregistrés');
  }

  return (
    <section class="page">
      <div class="sectionTitle">
        <div>
          <h1>Compte & réglages</h1>
          <p class="muted">Quelques infos de base.</p>
        </div>
      </div>

      <div class="card" style={{ maxWidth: '760px' }}>
        <div class="formGrid">
          <div>
            <label for="teacher">Prénom affiché</label>
            <input
              id="teacher"
              value={teacher}
              onInput={(e) => setTeacher(e.currentTarget.value)}
            />
          </div>
          <div>
            <label for="className">Classe</label>
            <select
              id="className"
              value={className}
              onChange={(e) => setClassName(e.currentTarget.value)}
            >
              {LEVELS.map((level) => (
                <option key={level} value={level}>
                  {LEVEL_LABELS[level]}
                </option>
              ))}
            </select>
            <p class="small muted" style={{ margin: '6px 0 0' }}>
              Détermine les attendus du tronc commun proposés dans les activités.
            </p>
          </div>
          <div>
            <label for="year">Année scolaire</label>
            <input
              id="year"
              value={schoolYear}
              onInput={(e) => setSchoolYear(e.currentTarget.value)}
            />
          </div>
        </div>

        <div style={{ marginTop: '14px' }}>
          <button class="btn primary" onClick={save}>
            Enregistrer
          </button>
        </div>
      </div>

      <SyncCard />
    </section>
  );
}

function SyncCard() {
  const phase = useSyncStatus((s) => s.phase);
  const pending = useSyncStatus((s) => s.pending);
  const lastSyncAt = useSyncStatus((s) => s.lastSyncAt);
  const lastError = useSyncStatus((s) => s.lastError);

  if (phase === 'disabled') return null;

  return (
    <div class="card" style={{ maxWidth: '760px', marginTop: '16px' }}>
      <div class="cardHead">
        <h3>Synchronisation</h3>
      </div>

      <p class="muted" style={{ marginTop: 0 }}>
        Tes données sont enregistrées sur cet appareil et envoyées automatiquement dès qu’une
        connexion est disponible.
      </p>

      <div class="stats" style={{ gridTemplateColumns: 'repeat(2,1fr)' }}>
        <div class="stat">
          <strong>{pending}</strong>
          <span class="small muted">Modification(s) à envoyer</span>
        </div>
        <div class="stat">
          <strong>
            {lastSyncAt ? new Date(lastSyncAt).toLocaleTimeString('fr-BE') : '—'}
          </strong>
          <span class="small muted">Dernière synchronisation</span>
        </div>
      </div>

      {lastError && (
        <div class="small muted" style={{ marginTop: '10px' }}>
          Dernière erreur : {lastError}
        </div>
      )}

      <div class="row" style={{ marginTop: '14px' }}>
        <button class="btn soft" onClick={() => void syncNow()}>
          Synchroniser maintenant
        </button>
        <button
          class="btn ghost"
          title="Retélécharge tout le journal depuis le serveur. Tes modifications en attente sont conservées."
          onClick={() => {
            void resyncFromScratch();
            toast('Retéléchargement du journal…');
          }}
        >
          Tout retélécharger
        </button>
        <SignOutButton />
      </div>
    </div>
  );
}
